/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import DesignEditor from 'shared/ui/components/editors/design/DesignEditor.vue';
import DesignPreview from 'shared/ui/components/editors/design/DesignPreview.vue';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';
import JsonEditor from 'ui/components/dev-tools/document-editor/JsonEditor.vue';

const __vue_script__ = {
    name: 'BadgeLayout',

    components: { BaseInput, BaseSelect, DesignEditor, DesignPreview, JsonEditor, InputWithUnit },

    props: {
        event: {
            type: Object,
            required: true
        },

        user: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            default: () => ({
                mode: 'standalone'
            })
        },

        value: {
            type: Object,
            default: () => ({
                name: '',
                type: {}
            })
        },

        disabled: {
            type: Boolean,
            default: false
        },

        saveSpy: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            dpi: 0,
            height: 0,
            innerValue: {},
            metadata: null,
            name: null,
            pages: [],
            preset: {},
            presets: [],
            ready: false,
            unit: {},
            units: [],
            width: 0,
            /*
             * NOTE: Once the editor implements texts picker and other
             * tools, this field could either be removed or set depending
             * on a flag.
             *
             * For the time being we keep it hardcoded to false until the
             * time we will be able to remove the JSON editor.
             */
            useEditor: Boolean(this.event.use_editor_for_designs)
        };
    },

    computed: {
        /** @returns {boolean} */
        isEditing() {
            return Boolean(this.value._id);
        },

        previewHeight() {
            return this.computeSize(this.height);
        },

        previewWidth() {
            return this.computeSize(this.width);
        }
    },

    watch: {
        value() {
            this.init();
        },

        saveSpy() {
            this.save();
        }
    },

    async created() {
        try {
            const metadata = await this.$services.metadata.getMetadataForType(this.event._id, 'badge_design');
            const presets = metadata.preset.kind_options.values;

            this.metadata = metadata;
            this.presets = presets;
            this.units = metadata.unit.kind_options.values;

            this.ready = true;

            this.init();
        } catch (error) {
            console.error('[BadgeLayout] Could not load initial data', error);
        }
    },

    methods: {
        init() {
            if (!this.ready) return;

            this.preset = this.presets.find(p => p.value === (this.value.preset || 'other'));
            this.width = this.value.width || this.preset.width;
            this.height = this.value.height || this.preset.height;
            this.dpi = this.value.dpi || this.preset.dpi || this.metadata.dpi.kind_options.default;
            this.unit = this.units.find(u => u.value === (this.value.unit || this.preset.unit)) || this.units[0];
            this.pages = this.value.pages || [{ blocks: {} }];
            this.name = this.value.name;
        },

        applyPreset(preset) {
            if (preset) {
                this.width = preset.width;
                this.height = preset.height;
                this.unit = preset.unit;
                this.dpi = preset.dpi;
                this.unit = this.units.find(u => u.value === preset.unit);
            }
        },

        computeSize(size) {
            const dpcm = this.dpi / 25.4;
            const dp = this.unit.value === 'in' ? this.dpi : dpcm;
            return dp * size;
        },

        async save() {
            const valid = await this.$refs['form'].validate();
            if (valid) {
                this.emit('save');
            }
        },

        emit(event = 'input') {
            Object.assign(this.innerValue, this.value);

            this.innerValue.preset = this.preset.value;
            this.innerValue.format = this.preset.label;
            this.innerValue.width = this.width;
            this.innerValue.height = this.height;
            this.innerValue.dpi = this.dpi;
            this.innerValue.unit = this.unit.value;
            this.innerValue.pages = this.pages;
            this.innerValue.name = this.name;

            this.$emit(event, this.innerValue);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('validation-observer',{ref:"form",staticClass:"badge-layout panels panels-c",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"panel"},[_c('validation-provider',{attrs:{"slim":true,"name":"name","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"name":"name","disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_name'),"errors":errors},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})]}}],null,false,2643401790)}),_c('validation-provider',{attrs:{"slim":true,"name":"preset","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"preset","allow-blank":false,"options":_vm.presets,"disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_preset'),"errors":errors},on:{"input":_vm.applyPreset},model:{value:(_vm.preset),callback:function ($$v) {_vm.preset=$$v},expression:"preset"}})]}}],null,false,350799499)}),(_vm.preset.value === 'other')?[_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"slim":true,"name":"dpi","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"type":"number","min":"1","name":"dpi","disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_dpi'),"errors":errors},model:{value:(_vm.dpi),callback:function ($$v) {_vm.dpi=$$v},expression:"dpi"}})]}}],null,false,3216343876)}),_c('validation-provider',{attrs:{"slim":true,"name":"unit","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"unit","allow-blank":false,"options":_vm.units,"disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_unit'),"errors":errors},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}})]}}],null,false,379737671)})],1)]),_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"slim":true,"name":"width","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","min":"1","name":"width","disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_width'),"errors":errors},model:{value:(_vm.width),callback:function ($$v) {_vm.width=$$v},expression:"width"}},[_c('span',[_vm._v(_vm._s(_vm.unit.value))])])]}}],null,false,1480120020)}),_c('validation-provider',{attrs:{"slim":true,"name":"height","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-unit',{attrs:{"type":"number","min":"1","name":"height","disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.design.layout_height'),"errors":errors},model:{value:(_vm.height),callback:function ($$v) {_vm.height=$$v},expression:"height"}},[_c('span',[_vm._v(_vm._s(_vm.unit.value))])])]}}],null,false,140879821)})],1)])]:_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"pages"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('json-editor',{attrs:{"emit-on-change":true,"errors":errors,"event-id":_vm.event._id,"main-menu-bar":false,"set-content-on-value-changes":_vm.useEditor,"mode":"text"},on:{"reset":_vm.init,"input":function (p) { return _vm.emit('input', p); }},model:{value:(_vm.pages),callback:function ($$v) {_vm.pages=$$v},expression:"pages"}})]}}],null,false,950709581)})],2),(_vm.isEditing && _vm.previewHeight && _vm.previewWidth)?_c('div',{staticClass:"panel"},[(_vm.useEditor)?[_c('design-editor',{attrs:{"event":_vm.event,"height":_vm.previewHeight,"width":_vm.previewWidth},model:{value:(_vm.pages),callback:function ($$v) {_vm.pages=$$v},expression:"pages"}})]:[_c('design-preview',{attrs:{"event":_vm.event,"height":_vm.previewHeight,"width":_vm.previewWidth,"value":_vm.pages}})]],2):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BadgeLayout.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__